<script setup lang="ts">
const props = defineProps<{
  modelValue: number;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: number];
}>();

function setValue(value: number) {
  emit("update:modelValue", Math.max(value, 0));
}
</script>

<template>
  <div
    class="inline-flex h-[48px] lg:h-[68px] items-center gap-2 lg:gap-4 rounded-full border border-brand/10 bg-white p-1 lg:p-2"
  >
    <button
      class="grid min-w-10 w-10 h-10 lg:min-w-[52px] lg:h-[52px] lg:w-[52px] place-items-center rounded-full bg-brand text-2xl font-medium leading-none text-white transition disabled:bg-brand/30 cursor-pointer"
      type="button"
      aria-label="Уменьшить количество"
      :disabled="modelValue === 0"
      @click="setValue(modelValue - 1)"
    >
      <svg class="min-w-6 h-6 w-6 text-white" viewBox="0 0 24 24" fill="none">
        <use href="#ticket-widget-icon-minus" />
      </svg>
    </button>
    <span
      class="min-w-8 text-center text-xl lg:text-2xl leading-6 lg:leading-7 font-semibold text-ink"
    >
      {{ modelValue }}
    </span>
    <button
      class="grid min-w-10 w-10 h-10 lg:min-w-[52px] lg:h-[52px] place-items-center rounded-full bg-brand text-3xl font-medium leading-none text-white transition disabled:bg-brand/30 cursor-pointer"
      type="button"
      aria-label="Увеличить количество"
      @click="setValue(modelValue + 1)"
    >
      <svg class="min-w-6 h-6 w-6 text-white" viewBox="0 0 24 24" fill="none">
        <use href="#ticket-widget-icon-plus" />
      </svg>
    </button>
  </div>
</template>
